import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import Security from '../images/security.gif'

class PrimaryFooter extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {		
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {	

		return(<div>
			<div id="footer">
				<div id="imlinks"><b><strong style={{color:'white'}}>Copyright &#169; 2011 {this.state.CompName} All rights reserved</strong></b></div>
			</div><br/><br/><br/>
			<div style={{textAlign: "center"}}>
				<Link style={{color:'grey'}} to="/Manages">Home</Link>|
				<Link style={{color:'grey'}} to="/Cashadvance">Cash Advance</Link>|
				<Link style={{color:'grey'}} to="/Onlinepaydayloans">Online Payday Loans</Link>|
				<Link style={{color:'grey'}} to="/Badcreditloans" >Bad Credit Loans</Link>|
				<Link style={{color:'grey'}} to="/Financials">Finances</Link>|
				<Link style={{color:'grey'}} to="/Tool" >Tools</Link> |
				<Link style={{color:'grey'}} to="/Contact" >Contact Us</Link>|
				<Link style={{color:'grey'}} to="/Privacypolicy">Privacy Policy</Link>
			</div><br/><br/><br/>
			<div><img src={Security} alt="Payday loans seurity logo"/>				
			</div>
		</div>)
	}
}
export default PrimaryFooter

